// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type RevokeAllOrganizationOauthTokensMutationVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type RevokeAllOrganizationOauthTokensMutation = {
  __typename?: "Mutation";
  revokeAllOrganizationOauthTokens: {
    __typename?: "RevokeAllOrganizationOauthTokensPayload";
    success: boolean;
    tokensRevoked: number;
  };
};

export const RevokeAllOrganizationOauthTokensDocument = gql`
  mutation RevokeAllOrganizationOauthTokens($organizationSlug: ID!) {
    revokeAllOrganizationOauthTokens(organizationSlug: $organizationSlug) {
      success
      tokensRevoked
    }
  }
`;
export type RevokeAllOrganizationOauthTokensMutationFn =
  Apollo.MutationFunction<
    RevokeAllOrganizationOauthTokensMutation,
    RevokeAllOrganizationOauthTokensMutationVariables
  >;

/**
 * __useRevokeAllOrganizationOauthTokensMutation__
 *
 * To run a mutation, you first call `useRevokeAllOrganizationOauthTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeAllOrganizationOauthTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeAllOrganizationOauthTokensMutation, { data, loading, error }] = useRevokeAllOrganizationOauthTokensMutation({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useRevokeAllOrganizationOauthTokensMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeAllOrganizationOauthTokensMutation,
    RevokeAllOrganizationOauthTokensMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RevokeAllOrganizationOauthTokensMutation,
    RevokeAllOrganizationOauthTokensMutationVariables
  >(RevokeAllOrganizationOauthTokensDocument, options);
}
export type RevokeAllOrganizationOauthTokensMutationHookResult = ReturnType<
  typeof useRevokeAllOrganizationOauthTokensMutation
>;
export type RevokeAllOrganizationOauthTokensMutationResult =
  Apollo.MutationResult<RevokeAllOrganizationOauthTokensMutation>;
export type RevokeAllOrganizationOauthTokensMutationOptions =
  Apollo.BaseMutationOptions<
    RevokeAllOrganizationOauthTokensMutation,
    RevokeAllOrganizationOauthTokensMutationVariables
  >;
